import { useTranslation } from 'react-i18next';

import * as graphql from '@treams/treams-network';
import { FlexGap, Paragraph, Spinner, tokens } from '@treams/treams-ui';

import HelpLink from '../../packages/kakapo-ui-kit/components/intercom/HelpLink';
import SettingsCollection from '../generic/SettingsCollection';
import CreateDepartment from './CreateDepartment';
import OrganizationDepartmentsTree from './OrganizationDepartmentsTree';

export default function OrganizationDepartments() {
	const { t } = useTranslation();

	const query = graphql.useDepartmentsWithParentsQuery({
		variables: {
			filter: {
				types: [graphql.GroupType.Department],
				isArchived: false,
			},
			first: 1000,
		},
	});

	return (
		<FlexGap flexDirection="column" gap={tokens.gap.page} width="100%">
			<HelpLink id="help.settings.departments" />
			<FlexGap flexDirection="column" gap={tokens.gap.group} width="100%">
				<FlexGap alignItems="center" justifyContent="space-between" width="100%">
					<Paragraph mb={0} mr={3}>
						{t('settings.departments.description')}
					</Paragraph>
					<CreateDepartment />
				</FlexGap>
				{query.data ? (
					<OrganizationDepartmentsTree
						groups={query.data.groups.edges.map(({ node }) => node as graphql.Group)}
					/>
				) : (
					<Spinner centered />
				)}
			</FlexGap>
			<SettingsCollection
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				lazyQuery={graphql.useDepartmentsLazyQuery as any}
				field="groups"
				translationKey="settings.departments"
				title={(group: graphql.Group) => group.name}
				link={(title) => `/settings/organization/departments/${title.id}`}
				variables={{}}
			/>
		</FlexGap>
	);
}
